<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import progressApi from '@/services/api/progress.api'
import stipulation15Sources from '@/utils/constants/stipulation15Sources';

export default {
  components: {
    FilterManager,
    PageHeader,
  },
  data: () => 
  ({
    page: {
      title: 'Informes de Progreso: Estipulación 15',
        icon: 'fas fa-calculator',
        routes: ['Inicio', 'Informes de Progreso', 'Estipulación 15'],
    },
    model: {
      search: {
        collections: {
          sources: [],
        },
        filters: {
          dateFrom: null,
          dateTo: null,
          source: null,
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'dateFrom',
        component: 'custom-date-picker',
        label: 'Fecha Desde',
        placeholder: 'Fecha Desde',
        error: 'Favor seleccionar la fecha de comienzo.',
        validations: 'required',
        class: 'col-md-3',
        classContainer: 'date-width-container',
        maxDate: new Date(),
        value: this.model.search.filters.dateFrom,
      },
      {
        name: 'dateTo',
        component: 'custom-date-picker',
        label: 'Fecha Hasta',
        placeholder: 'Fecha Hasta',
        error: 'Favor seleccionar la fecha de finalización.',
        validations: 'required',
        classContainer: 'date-width-container',
        class: 'col-md-3',
        maxDate: new Date(),
        value: this.model.search.filters.dateTo,
        minDate: this.model.search.filters.dateFrom,
      },
      {
        name: 'source',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Imágenes a generar',
        placeholder: 'Seleccionar',
        clearable: true,
        class: "col-md-3",
        validations: 'required',
        error: 'El tipo de imagenes a generar es requerido.',
        options: this.model.search.collections.sources,
        value: this.model.search.filters.source,
        disabled: this.model.search.collections.sources.length <= 0,
      },
    ]},
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      this.model.search.collections.sources = [
        {
          id: stipulation15Sources.PEI,
          name: 'PEI'
        },
        {
          id: stipulation15Sources.Registro,
          name: 'Registro'
        }
      ];
    },
    async onHandlerSearch() {
      if (this.model.search.filters.dateFrom > this.model.search.filters.dateTo) {
        this.ShowToast(
          'Atención',
          'La Fecha Hasta no puede ser menor a la Fecha Desde.',
          'error'
        )
        return;
      }

      if (this.model.search.filters.dateFrom !== null && this.model.search.filters.dateTo !== null) {
        this.process();
      }
    },
    async process() {
      if (!this.model.search.filters.source?.id) return;

      const filters = {
        dateFrom: this.model.search.filters.dateFrom,
        dateTo: this.model.search.filters.dateTo,
        sourceId: this.model.search.filters.source?.id,
      };

      try {
        await progressApi.generateStipulation15Attachments(filters);
        
        this.ShowToast(
          'Proceso Exitoso',
          'Comenzó el proceso de generación imágenes de la Tarea 15 exitosamente. Una vez culmine se envará un correo electrónico con enlace para descargar las mismas.',
          'success'
        );
      } catch (err) {
        this.ShowToast(
          '',
          err.response?.data?.message || err.message,
          'error'
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/views/progress/shared/scss/common.scss';
</style>
